import Grid from '@mui/material/Grid';

import BlogCuratedArticleList from '@/components/BlogComponents/BlogCuratedArticleList/BlogCuratedArticleList';
import GridContainer from '@/components/Layout/GridContainer/GridContainer';
import { SpacingContainer } from '@/components/SpacingContainer/SpacingContainer';
import type { CuratedArticleSplitType } from '@/contentful/api/api.types';

import useStyles from './BlogCuratedArticleSplit.styles';
import BlogCuratedArticleSquareCard from './BlogCuratedArticleSquareCard/BlogCuratedArticleSquareCard';

export default function BlogCuratedArticleSplit({
  content,
}: {
  content: CuratedArticleSplitType;
}): React.JSX.Element {
  const { classes } = useStyles();
  const { articlesCollection, articleListHeading } = content;

  const featuredArticle = articlesCollection.items[0];
  const listOfArticles = articlesCollection.items.slice(1);

  return (
    <SpacingContainer
      isFeatured
      className={classes.spacingContainer}
      data-testid='blogCuratedArticleSplit'
    >
      <GridContainer fixed>
        <Grid className={classes.gridItem}>
          <BlogCuratedArticleSquareCard featuredArticle={featuredArticle} />
          <BlogCuratedArticleList
            heading={articleListHeading}
            articles={listOfArticles}
          />
        </Grid>
      </GridContainer>
    </SpacingContainer>
  );
}
